import {Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {ModalDirective} from "ngx-bootstrap";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-license-modal',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.scss']
})
export class LicenseComponent implements OnInit, OnChanges {

  @ViewChild('modal') public modal: ModalDirective;
  @Input() profile: any;
  @Input() shouldAgree: boolean = true;
  @Input() private isHidden: boolean = true;
  @Output() private agreeToTermsEvent: EventEmitter<any> = new EventEmitter();
  @Output() private modalCloseEvent: EventEmitter<any> = new EventEmitter();

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: any) {
    if(changes.profile) {
      this.profile = changes.profile.currentValue;
      this.byPassLicenceUrl();
    }
    if(changes.isHidden) {
      this.isHidden = changes.isHidden.currentValue;
      if(this.isHidden) {
        this.hideModal();
      } else {
        this.showModal();
      }
    }
  }

  termsAgreed(value){
    this.agreeToTermsEvent.emit(value);
  }

  public showModal(): void {
    this.modal.config.backdrop = false;
    this.modal.show();
  }

  public hideModal(): void {
    this.modal.hide();
    this.isHidden = true;
    this.modalCloseEvent.emit(true);
  }

  byPassLicenceUrl() {
    if(this.profile && this.profile.licenseURL)
      this.profile.vendorUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.profile.licenseURL+'#zoom=115');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/buyer/license/license.component.ts